import {
  RESET_ADMIN_USER_PASSWORD_REQUEST,
  RESET_ADMIN_USER_PASSWORD_SUCCESS,
  RESET_ADMIN_USER_PASSWORD_FAILURE,
} from '../../../../Constants/actionTypes';

import { resetAdminUserPasswordApi } from '../../../../Constants/apiService';

export const resetAdminUserPasswordRequest = () => ({ type: RESET_ADMIN_USER_PASSWORD_REQUEST });
export const resetAdminUserPasswordSuccess = () => ({ type: RESET_ADMIN_USER_PASSWORD_SUCCESS });
export const resetAdminUserPasswordFailure = (error) => ({
  type: RESET_ADMIN_USER_PASSWORD_FAILURE,
  payload: error,
});

export const resetAdminUserPasswordAct = (email) => {
  return async (dispatch, getState) => {
    dispatch(resetAdminUserPasswordRequest());

    const accessToken = getState()?.auth?.accessToken;

    try {
      const data = await resetAdminUserPasswordApi(email, accessToken);
      dispatch(resetAdminUserPasswordSuccess());
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently unavailable. Please try again later.'
          : error?.message || 'Unable to reset the password. Please try again.';

      dispatch(resetAdminUserPasswordFailure(errorMessage));
      throw new Error(errorMessage);
    }
  };
};
